// Module 7 — EveryDollar Walkthrough
// ./index.ts owns this module's key and display name; this file owns its
// action items.

// RDS
import Heading from '@ramsey-design-system/heading';
import { VideoOutlinedIcon } from '@ramsey-design-system/icons';
import Text from '@ramsey-design-system/text';

// Components
import HLSVideoPlayer from '~fpu/shared/components/HLSVideoPlayer';
import QrCodePrompt from '../QrCodePrompt';

// Utils
import storeConfig from '~fpu/config/storeConfig';

// Types
import { WorkshopActionItemDefinition } from '../../types';

function GettingStartedInEveryDollar() {
  return (
    <QrCodePrompt
      activityUrl={storeConfig.everydollar}
      slug="everydollar-app"
      dialogTitle="Download the EveryDollar App"
    >
      <Heading level="3" size="small">
        Download the EveryDollar App
      </Heading>
      <Text className="text-4 leading-lg">
        Your budget is only as good as your ability to access it. Download
        EveryDollar and have your budget with you wherever you go.
      </Text>
    </QrCodePrompt>
  );
}

function SettingUpYourBudgetClip() {
  return (
    <HLSVideoPlayer
      src="https://cdn.ramseysolutions.net/media/ramsey-plus/financial-peace/coordinator/dashboard/budget-workshop-assets/setting-up-your-budget.mp4"
      thumbnail="https://cdn.ramseysolutions.net/media/ramsey-plus/financial-peace/coordinator/dashboard/budget-workshop-assets/setting-up-your-budget.png"
    />
  );
}

function BankConnectClip() {
  return (
    <HLSVideoPlayer
      src="https://cdn.ramseysolutions.net/media/ramsey-plus/financial-peace/coordinator/dashboard/budget-workshop-assets/bank-connect.mp4"
      thumbnail="https://cdn.ramseysolutions.net/media/ramsey-plus/financial-peace/coordinator/dashboard/budget-workshop-assets/bank-connect.png"
    />
  );
}

const actionItems: WorkshopActionItemDefinition[] = [
  {
    title: 'Getting Started in EveryDollar',
    Content: GettingStartedInEveryDollar
  },
  {
    title: 'Setting Up Your Budget',
    Content: SettingUpYourBudgetClip,
    icon: VideoOutlinedIcon,
    duration: '4:20'
  },
  {
    title: 'Bank Connect',
    Content: BankConnectClip,
    icon: VideoOutlinedIcon,
    duration: '1:41'
  }
];

export default actionItems;
